import {useLayoutEffect} from 'react';
import {create} from 'zustand';

export const BOOT_BACKDROP_KEY = 'chekin-boot-backdrop';
export const BOOT_BACKDROP_ATTRIBUTE = 'data-boot-backdrop';

const BACKDROP_LAYERS =
  'linear-gradient(180deg, transparent 35%, color-mix(in srgb, var(--chekin-blue-950) 55%, transparent) 100%), var(--chekin-gradient-duotone)';

export function rememberBootBackdrop() {
  const probe = document.createElement('div');
  probe.style.background = BACKDROP_LAYERS;
  document.body.appendChild(probe);
  const backdrop = getComputedStyle(probe).backgroundImage;
  probe.remove();

  if (!backdrop || backdrop === 'none') {
    return;
  }

  try {
    sessionStorage.setItem(BOOT_BACKDROP_KEY, backdrop);
  } catch {
    return;
  }
}

type FirstScreenStore = {
  readyAt: number;
  markReady: () => void;
};

export const useFirstScreenStore = create<FirstScreenStore>(set => ({
  readyAt: 0,
  markReady: () => set({readyAt: performance.now()}),
}));

export function useFirstScreenReady() {
  const markReady = useFirstScreenStore(state => state.markReady);

  useLayoutEffect(
    function revealFirstScreen() {
      document.documentElement.removeAttribute(BOOT_BACKDROP_ATTRIBUTE);
      markReady();
    },
    [markReady],
  );
}
